export const ValorantDivisions = [
  'Iron I',
  'Iron II',
  'Iron III',
  'Bronze I',
  'Bronze II',
  'Bronze III',
  'Silver I',
  'Silver II',
  'Silver III',
  'Gold I',
  'Gold II',
  'Gold III',
  'Platinum I',
  'Platinum II',
  'Platinum III',
  'Diamond I',
  'Diamond II',
  'Diamond III',
  'Ascendant I',
  'Ascendant II',
  'Ascendant III',
  'Immortal I',
  'Immortal II',
  'Immortal III',
  'Radiant',
  'Unranked',
];
